/**
 * WordPress dependencies
 */
import { Modal } from '@safe-wordpress/components';

/**
 * Internal dependencies
 */
import './style.scss';
import { ManageContent } from './manage-content';
import { AddEntityContent } from './add-entity-content';

export type ReusableEntitiesDialogProps<
	T extends { readonly attributes: { readonly name: string } },
> =
	| {
			readonly mode: 'manage';
			readonly labels: {
				readonly title: string;
				readonly add?: string;
				readonly manageElements?: string;
				readonly replace?: string;
				readonly selectMultiple?: string;
				readonly selectSingle?: string;
			};
			readonly items: ReadonlyArray< T >;
			readonly saving: boolean;
			readonly isSingular?: boolean;
			readonly onClose: () => void;
			readonly onAdd?: ( items: ReadonlyArray< T > ) => void;
			readonly onReplace?: ( items: ReadonlyArray< T > ) => void;
			readonly onSave?: (
				items: ReadonlyArray< T >
			) => Promise< unknown >;
	  }
	| {
			readonly mode: 'save';
			readonly labels: {
				readonly title: string;
				readonly collectionName: string;
				readonly nameField: string;
				readonly newItemOption: string;
			};
			readonly item: T;
			readonly items: ReadonlyArray< T >;
			readonly saving: boolean;
			readonly onClose: () => void;
			readonly onSave: (
				items: ReadonlyArray< T >
			) => Promise< unknown >;
	  };

export function ReusableEntitiesDialog<
	T extends { readonly attributes: { readonly name: string } },
>( props: ReusableEntitiesDialogProps< T > ): JSX.Element | null {
	return (
		<Modal
			className="nelio-ab-testing-reusable-entities-dialog"
			title={ props.labels.title }
			onRequestClose={ props.saving ? () => void null : props.onClose }
		>
			{ 'manage' === props.mode ? (
				<ManageContent { ...props } />
			) : (
				<AddEntityContent { ...props } />
			) }
		</Modal>
	);
}
